import { LockIcon } from '@phosphor-icons/react'

import { TimeBlock } from '@/api/reservations/get-time-blocks'

// A time block as mapped for the calendar (mapTimeBlockToCalendarEvent): locationId is
// flattened to the id, with the space's name moved to locationName
type CalendarTimeBlock = Omit<TimeBlock, 'locationId'> & {
  locationId: number | null
  locationName: string | null
}

export const WeekAndDayTimeBlock = ({ timeBlock }: { timeBlock: CalendarTimeBlock }) => {
  const reason = timeBlock.reasonOther || timeBlock.reason
  const amenity = timeBlock.amenityId.name
  const location = timeBlock.locationName
  const title = `${reason} - ${amenity}${location ? ` (${location})` : ''}`

  return (
    <div className="ctp-event">
      <div className="ctp-event__overlay week-and-day-time-block">
        <div className="ctp-event__title">
          <LockIcon />
          {title}
        </div>
      </div>
    </div>
  )
}
